module.exports = __webpack_public_path__ + "static/media/buy_view.07191fe3.svg";